<template>
    <el-menu-item v-if="!isSubMenu" :index="menu.index"  ref="menu" >
        <!-- <i v-if="hasIcon" :class="`iconfont ${menu.icon}`"></i> -->
        <!-- <template v-if="level == 1">&nbsp;&nbsp;&nbsp;&nbsp;</template> -->
        {{menu.text}}就
    </el-menu-item>
    <el-submenu v-else :index="menu.index">
        <template slot="title">
            <!-- <i v-if="hasIcon" :class="`iconfont ${menu.icon}`"></i> -->
            <!-- <template v-if="level == 1">&nbsp;&nbsp;&nbsp;&nbsp;</template> -->
            {{menu.text}}
        </template>
        <slot :menus="menu.children" :level="level+1"  />
    </el-submenu>
</template>
<script>
export default {
    data() {
        return {
            isSubMenu:true
        };
    },
    props: {
        menu: {
            type: Object,
            default: {},
        },
        level: {
            type: Number,
            default: 1,
        },
        active: {
            type: String,
            default: "index",
        },
    },
    computed:{
        isSubMenu(){
            // debugger
            // this.isSubMenu = typeof this.menu.children == 'object' && this.menu.children instanceof Array
        }
    },
    activated() {},
    deactivated() {},
    methods: {},
};
</script>